import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// icons
import DeleteIcon from '@mui/icons-material/Delete'
// utils
import { size, darken } from 'polished'

export const Title = styled('div')`
  font-size: 12px;
  color: ${colors.gray300};
`

export const RowWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-top: 12px;

  & > div {
    flex: 1;
  }

  svg {
    margin-left: 12px !important;
  }
`

export const TrashIcon = styled(DeleteIcon)`
  cursor:pointer;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }

  &:hover {
    path {
      fill: ${darken(0.10, colors.blue500)};
    }
  }
`
